import { Injectable } from "@angular/core";
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { RouterAuthorizerService } from "./router-authorizer.service";
import { SessionService } from "./session.service";
import { RoleType } from "../models/AccountModel";

@Injectable({
  providedIn: 'root'
})
export class AdminRedirectGuard implements CanActivate {
  constructor(private authService: RouterAuthorizerService, private router: Router, private _sessionService: SessionService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.hasRole(RoleType.ADMIN) ||  this.hasRole(RoleType.SUPPORT_ADMIN) ) {
      return this.router.parseUrl('/secured/admin/accounts');
    } else if(this.hasRole(RoleType.CERTIFICATION_ADMIN)) {
      return this.router.parseUrl('/secured/admin/certification');
    } else {
      let qp = {};
      qp['autoSso'] = false;
      this.router.navigate(['/public/login'], { queryParams: qp });
    }
  }

  private hasRole(role: string){
    let isAuthorized = false;
    if (this._sessionService.hasRole(role)) {
      isAuthorized = true;
    }
    return isAuthorized;
  }
}